<div class="data-for-print">
  <img src="/assets/img/newImg/logo.svg" alt="logo" class="logo-for-print" title="logo"/>
  @if (!printOptions.includes(printOptionType.TradingPlan)) {
    <app-search-bar [isPowerX]="true"></app-search-bar>
    @if (printOptions.includes(printOptionType.Chart)) {
      <div class="page-break">
        <p class="print-section-title">Chart</p>
        <div id="print-chart" class="print-chart-container page-break"></div>
      </div>
    }
    @if (printOptions.includes(printOptionType.DataWindow)) {
      <div class="page-break">
        <p class="print-section-title">Data window</p>
        <app-data-window [isPrint]="true" class="print-data-window"></app-data-window>
      </div>
    }
    @if (printOptions.includes(printOptionType.TradingReport)) {
      <div class="page-break">
        <app-trading-report
          [isPrint]="true"
          [isReportFitOnPrintScreen]="isReportFitOnScreen">
        </app-trading-report>
      </div>
    }
    @if (printOptions.includes(printOptionType.Options)) {
      <div>
        <p class="print-section-title">Options</p>
        <app-options [isPrint]="true"></app-options>
      </div>
    }
  }

  @if (printOptions.includes(printOptionType.TradingPlan)) {
    <div>
      <app-print-trading-plan></app-print-trading-plan>
    </div>
  }
</div>
